/* unplugin-vue-components disabled */import script from "./Cxcyqy.vue?vue&type=script&lang=ts&setup=true"
export * from "./Cxcyqy.vue?vue&type=script&lang=ts&setup=true"

import "./Cxcyqy.vue?vue&type=style&index=0&id=ff6c0806&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff6c0806"]])

export default __exports__